import { statusLabel, statusTone } from '../../utils/billingStatus';

export default function BillingStatusPill({ status, trialExpired = false }) {
    return (
        <span className={`billing-pill billing-pill--${statusTone(status)}`}>
            <span className="billing-pill-dot" />
            {statusLabel(status, { trialExpired })}
        </span>
    );
}
